import type { IUser } from '@/interfaces/IUser';

interface IUserState {
  user: IUser | null;
  isLoading: boolean;
  profileSetup: boolean;
}

export default (): IUserState => ({
  user: {
    id: '',
    sub: '',
    email: '',
    firstName: '',
    lastName: '',
    fullName: '',
    role: undefined,
    tier: undefined,
    phone: '',
  } as IUser,
  isLoading: false,
  profileSetup: false,
});
